/* eslint-disable import/prefer-default-export */

export function createHiddenInput(name: string, value: string) {
  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = name;
  input.value = value;
  return input;
}

/**
 * Determines whether a DOM node represents an editable context where
 * global keyboard shortcuts (e.g. Ctrl+K for the command palette)
 * should be suppressed.
 *
 * Returns `true` for elements where the user is expected to type or edit content,
 * including:
 * - Text-like `<input>` elements (excluding submit, reset, checkbox, radio, file)
 * - `<textarea>` elements
 * - `<select>` elements
 * - Elements with `contenteditable` enabled
 *
 * Non-HTMLElement nodes always return `false`.
 *
 * @param element - The DOM node that received the keyboard event
 * @returns `true` if global shortcuts should be ignored for this element
 */
export function isEditableElement(element: Node): boolean {
  if (!(element instanceof HTMLElement)) {
    return false;
  }

  const name = element.nodeName.toLowerCase();
  const type = (element.getAttribute('type') || '').toLowerCase();
  if (name === 'select' || name === 'textarea' || element.isContentEditable) {
    return true;
  }

  return (
    name === 'input' &&
    type !== 'submit' &&
    type !== 'reset' &&
    type !== 'checkbox' &&
    type !== 'radio' &&
    type !== 'file'
  );
}
